import AlurPeminjamanTextIndividu from "./AlurPeminjamanTextIndividu";
import React from "react";
import {Button} from 'primereact/button';
import AlurPeminjamanTextProduktif from "./AlurPeminjamanTextProduktif";

export default function PengajuanPinjaman({type, product}){
    return (
        type === 'individu' ?
            <div className="container-alur pinjaman-with-image">
                <img className="image-pinjaman"
                     src={require("../../../../assets/img/product/cara-peminjaman.png")}
                     alt='caraPeminjaman'/>
                <div className="text-section">
                    <h2 className="text-header">Cara Mengajukan Pinjaman</h2>
                    <AlurPeminjamanTextIndividu type={product}/>
                    <Button className="colorful-button-individu">Ajukan Pinjaman</Button>
                </div>
            </div>
            :
            <div className="container-alur pinjaman-with-image">
                <img className="image-pinjaman"
                     src={require("../../../../assets/img/product/cara-peminjaman.png")}
                     alt='caraPeminjaman'/>
                <div className="text-section">
                    <h2 className="text-header">Cara Mengajukan Pinjaman</h2>
                    <AlurPeminjamanTextProduktif type={product}/>
                    <Button link onClick={() =>  window.open(`${process.env.REACT_APP_LINK_COMPANY_WEB}`, '_blank')} className="colorful-button">Ajukan Pinjaman</Button>
                </div>
            </div>
    );
}